const es = {
  title: "ENCUESTA DEL RIDER",
  subtitle: "Ayudanos a conocer a tu atleta — 3 minutos.",
  aboutRider: "Sobre el Rider",
  programme: "Interes en el Programa",
  budget: "Disposicion Presupuestaria",
  contact: "Contacto",
  submit: "Enviar Encuesta",
  success: "Encuesta enviada con exito. Gracias!",
  riderName: "Nombre completo del rider",
  ageDob: "Edad / Fecha de nacimiento",
  country: "Pais de residencia",
  discipline: "Disciplina principal",
  level: "Nivel actual",
  yearsRiding: "Anos montando",
  results: "Resultados notables / equipo / patrocinador",
  goals: "Objetivos para los proximos 2-3 anos",
  option: "Opcion de interes",
  start: "Inicio preferido",
  howHeard: "Como supiste de LNMA?",
  costGuide: "Has revisado nuestra guia de costes?",
  budgetFit: "La matricula anual es de 52.000€. Como encaja en tus planes?",
  financial: "Es probable que necesites apoyo financiero / patrocinio?",
  readiness: "Que tan listo estas para avanzar?",
  parentName: "Nombre del padre/tutor",
  parentEmail: "Mejor email",
  phone: "Telefono / WhatsApp",
  anythingElse: "Algo mas que quieras que sepamos?",
  disciplines: { dh: "Descenso", enduro: "Enduro", xc: "Cross-country", slopestyle: "Slopestyle/Dirt", freeride: "Freeride", multiple: "Multiples/Indeciso" },
  levels: { starting: "Empezando", serious: "Montando en serio, sin competir", club: "Club/regional", national: "Nacional", international: "Internacional" },
  options: { full: "Ano completo €52,000", semester: "Semestre €28,000", summer: "Campamento de verano €3,200", unsure: "No estoy seguro" },
  starts: { y2027: "2027", y2028: "2028", asap: "En cuanto haya plaza", exploring: "Solo explorando" },
  costReviewed: { full: "Leida completa", skimmed: "Vista por encima", notyet: "Todavia no" },
  budgetFits: { ready: "Listo para proceder", fits: "Encaja, quiero hablar de pago", evaluating: "Todavia evaluando", beyond: "Mas de lo que podemos comprometer" },
  readinessOpts: { enrol: "Listo para inscribirme", considering: "Considerandolo seriamente, quiero una llamada", research: "Investigacion temprana", curious: "Solo curioso" },
};

const en = {
  title: "RIDER SURVEY",
  subtitle: "Help us understand your athlete — a 3-minute survey.",
  aboutRider: "About the Rider",
  programme: "Programme Interest",
  budget: "Budget Readiness",
  contact: "Contact",
  submit: "Submit Survey",
  success: "Survey submitted successfully. Thank you!",
  riderName: "Rider full name",
  ageDob: "Age / Date of birth",
  country: "Country of residence",
  discipline: "Primary discipline",
  level: "Current level",
  yearsRiding: "Years riding",
  results: "Notable results / team / sponsor",
  goals: "Goals over the next 2-3 years",
  option: "Option of interest",
  start: "Preferred start",
  howHeard: "How did you hear about LNMA?",
  costGuide: "Have you reviewed our cost guide?",
  budgetFit: "The full-year tuition is €52,000. How does this fit your plans?",
  financial: "Likely to need financial support / sponsorship?",
  readiness: "How ready to move forward?",
  parentName: "Parent/guardian name",
  parentEmail: "Best email",
  phone: "Phone / WhatsApp",
  anythingElse: "Anything you'd like us to know?",
  disciplines: { dh: "Downhill", enduro: "Enduro", xc: "Cross-country", slopestyle: "Slopestyle/Dirt", freeride: "Freeride", multiple: "Multiple/Undecided" },
  levels: { starting: "Just starting", serious: "Riding seriously, not yet competing", club: "Club/regional", national: "National", international: "International" },
  options: { full: "Full year €52,000", semester: "Semester €28,000", summer: "Summer camp €3,200", unsure: "Not sure" },
  starts: { y2027: "2027", y2028: "2028", asap: "As soon as a place is available", exploring: "Just exploring" },
  costReviewed: { full: "Read in full", skimmed: "Skimmed", notyet: "Not yet" },
  budgetFits: { ready: "Ready to proceed", fits: "Fits, want to discuss payment", evaluating: "Still evaluating", beyond: "Beyond what we can commit to" },
  readinessOpts: { enrol: "Ready to enrol", considering: "Seriously considering, want a call", research: "Early research", curious: "Just curious" },
};

export function getTranslations(lang) {
  return lang === "es" ? es : en;
}
